<script lang="ts">
	import { onDestroy } from 'svelte';
	import { format } from 'svelte-i18n';
	import { control_bluetooth_device_ios } from 'src/services/native_container_requests_ios';
	import { control_bluetooth_device_android } from 'src/services/native_container_requests_android';

	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import {
		// Button,
		// Modal,
		// Loader,
		Alert,
		DeviceButton,
		DeviceButtonV2,
		ControlsContainer,
	} from '@Shelly/shelly-design-system';
	// import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';
	import { app, os } from 'src/stores/session/native-bridge';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import TransitionWrapper from 'src/components/Utility/TransitionWrapper.svelte';

	export let device;

	let buzzerPlay = false;
	// let requestPending = false;

	// let beaconEnabled = device?.beaconEnabled ? device?.beaconEnabled : false;

	// let firstThreshold = false;
	// let secondThreshold = false;
	// let conditionsThreshold = false;

	const userPrompts = {
		firstThreshold: {
			alertShow: false,
			timeout: undefined,
		},
		secondThreshold: {
			alertShow: false,
			timeout: undefined,
		},
		conditionsThreshold: {
			alertShow: false,
			timeout: undefined,
		},
		connectedToDevice: {
			alertShow: false,
		},
	};

	const setBuzzerPlay = () => {
		// set controlled device id
		controlBleDevice.updateDeviceId(device.id);

		// if ($controlBleDevice.connectionState === 2 || $os !== 'IOS') {s
		if ($controlBleDevice.processRunning) {
			resetUserPrompts();
			controlBleDevice.updateProcessRunning(false);
			$os == 'IOS'
				? control_bluetooth_device_ios(device.id, 'abortConnecting')
				: control_bluetooth_device_android(device.id, 'abortConnecting');
		} else {
			controlBleDevice.updateProcessRunning(true);
			$os == 'IOS'
				? control_bluetooth_device_ios(device.id, buzzerPlay ? 'turnBuzzerOff' : 'turnBuzzerOn')
				: control_bluetooth_device_android(
						device.id,
						buzzerPlay ? 'turnBuzzerOff' : 'turnBuzzerOn',
					);

			userPrompts.firstThreshold.timeout = setTimeout(() => {
				userPrompts.firstThreshold.alertShow = true;
			}, 1000);

			userPrompts.secondThreshold.timeout = setTimeout(() => {
				userPrompts.secondThreshold.alertShow = true;
			}, 25000);

			userPrompts.conditionsThreshold.timeout = setTimeout(() => {
				userPrompts.conditionsThreshold.alertShow = true;
			}, 40000);
		}
		// } else {
		// 	$os == 'IOS'
		// 		? control_bluetooth_device_ios(device.id, 'connect')
		// 		: control_bluetooth_device_android(device.id, 'connect');
		// }
	};

	onDestroy((): void => {
		if (!$app) return;
		if ($controlBleDevice.connectionState === 2) {
			$os === 'IOS'
				? control_bluetooth_device_ios(device.id, 'disconnect')
				: control_bluetooth_device_android(device.id, 'disconnect');
		} else if ($controlBleDevice.connectionState === 1) {
			$os === 'IOS'
				? control_bluetooth_device_ios(device.id, 'abortConnecting')
				: control_bluetooth_device_android(device.id, 'disconnect');
		}
		controlBleDevice.reset();
	});

	const resetUserPrompts = () => {
		userPrompts.firstThreshold.alertShow = false;
		userPrompts.secondThreshold.alertShow = false;
		userPrompts.conditionsThreshold.alertShow = false;
		clearTimeout(userPrompts.firstThreshold.timeout);
		clearTimeout(userPrompts.secondThreshold.timeout);
		clearTimeout(userPrompts.conditionsThreshold.timeout);
	};

	// $: if ($controlBleDevice.currentErrorIndex > -1) {
	// 	requestPending = false;
	// }

	$: switch ($controlBleDevice.currentStatusIndex) {
		case 2:
			// if ($os !== 'IOS') {
			// 	control_bluetooth_device_ios(
			// 		device.id,
			// 		buzzerPlay ? 'turnBuzzerOff' : 'turnBuzzerOn'
			// 	);
			// }
			// $os == 'IOS'
			// 	? control_bluetooth_device_ios(
			// 			device.id,
			// 			buzzerPlay ? 'turnBuzzerOff' : 'turnBuzzerOn'
			// 	  )
			// 	: control_bluetooth_device_android(
			// 			device.id,
			// 			buzzerPlay ? 'turnBuzzerOff' : 'turnBuzzerOn'
			// 	  );

			controlBleDevice.updateProcessRunning(true);
			break;

		case 41:
			//buzzerPlayStateChanged
			console.log('buzzerPlayStateChanged', buzzerPlay);
			if ($controlBleDevice.processRunning) {
				// buzzerPlay = !buzzerPlay;
				controlBleDevice.updateProcessRunning(false);
				console.log('buzzerPlay', buzzerPlay);
			}
			break;

		case 44:
			// buzzerTurnedOn
			buzzerPlay = true;

			if ($controlBleDevice.processRunning) {
				userPrompts.connectedToDevice.alertShow = true;
				resetUserPrompts();
				controlBleDevice.updateProcessRunning(false);
			}
			break;

		case 45:
			// buzzerTurnedOff
			buzzerPlay = false;
			// if ($controlBleDevice.processRunning) {
			resetUserPrompts();
			controlBleDevice.updateProcessRunning(false);
			// }
			break;

		default:
			break;
	}
</script>

<div class="flex-full-height" />

<!-- {#if !beaconEnabled}
	<Alert
		type="warning"
		class="mb-m"
		heading={'Warning'}
		message={"Can not enable the 'Find button' functionality because the device bluetooth beacon is disabled."}
	/>
{/if} -->

{#if !$app}
	<Alert
		type="warning"
		isHeadingBold
		heading={$format('alert_heading_ble_devices_restricted', {
			default: 'Bluetooth Restricted',
		})}
		message={$format('alert_message_ble_devices_restricted', {
			default:
				'Bluetooth devices can be configured only via the Shelly Smart Control application.',
		})}
		class="mb-m"
	/>
{/if}

{#if $controlBleDevice.processRunning && $controlBleDevice.connectionState == 0}
	{#if userPrompts.conditionsThreshold.alertShow}
		<TransitionWrapper>
			<Alert
				type="warning"
				heading={$format('alert_heading_find_device_conditions', {
					default: 'Bluetooth conditions',
				})}
				message={$format('alert_message_find_device_conditions', {
					default:
						"'Find My Device' will work only if your mobile device is paired with the button and the Bluetooth Button Beacon was turned on before hand. ",
				})}
				class="mb-m"
			/>
		</TransitionWrapper>
	{/if}

	{#if userPrompts.firstThreshold.alertShow && !userPrompts.secondThreshold.alertShow}
		<!-- {#key firstThreshold || secondThreshold} -->
		<TransitionWrapper>
			<Alert
				type="info"
				heading={$format('alert_heading_find_device_suggestion', {
					default: 'Searching for your device.',
				})}
				message={$format('alert_message_find_device_suggestion', {
					default: 'The device will start beeping when found.',
				})}
				class="mb-m"
			/>
		</TransitionWrapper>
	{/if}

	{#if userPrompts.secondThreshold.alertShow}
		<TransitionWrapper>
			<Alert
				type="info"
				heading={$format('alert_heading_find_device_suggestion', {
					default: 'This is tough!',
				})}
				message={$format('alert_message_find_device_suggestion', {
					default: 'Try walking around with your phone to cover a wider range.',
				})}
				class="mb-m"
			/>
		</TransitionWrapper>
	{/if}
{/if}

{#if $controlBleDevice.processRunning && $controlBleDevice.connectionState > 0}
	<!-- Found the device. Connecting… -->
	<TransitionWrapper>
		<Alert
			type="success"
			heading={$format('alert_heading_device_found', {
				default: 'Found the device!',
			})}
			message={$format('alert_message_device_found', {
				default: 'Connecting…',
			})}
			class="mb-m"
		/>
	</TransitionWrapper>
{/if}

<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
	<svelte:fragment slot="first">
		{#if $showNewLayout}
			<DeviceButtonV2
				id="devicebutton-ycqe6bi"
				aria-label={$format('button_find_my_device', { default: 'Find My Device' })}
				disabled={!$app}
				isLoading={$controlBleDevice.processRunning}
				isActive={buzzerPlay}
				size={'l'}
				icon="fa fa-radar"
				variant="primary"
				on:click={(e) => {
					e.stopPropagation();
					setBuzzerPlay();
				}}
			/>
		{:else}
			<DeviceButton
				id="devicebutton-ycqe6bi"
				aria-label={$format('button_find_my_device', { default: 'Find My Device' })}
				disabled={!$app}
				isWide
				isLoading={$controlBleDevice.processRunning}
				isActive={buzzerPlay}
				size={'l'}
				icon="fa fa-radar"
				variant="primary"
				on:click={(e) => {
					e.stopPropagation();
					setBuzzerPlay();
				}}
			/>
		{/if}
	</svelte:fragment>
</ControlsContainer>

<!-- <Button
	variant={buzzerPlay ? 'danger' : 'primary'}
	{loading}
	disabled={!beaconEnabled}
	size="m"
	class="text-uppercase"
	width="full"
	on:click={setBuzzerPlay}
	>{buzzerPlay ? 'Turn Buzzer On' : 'Turn Buzzer Off'}</Button
> -->
